import { render, staticRenderFns } from "./ChatPanel.vue?vue&type=template&id=d4a96bfe&scoped=true"
import script from "./ChatPanel.vue?vue&type=script&lang=js"
export * from "./ChatPanel.vue?vue&type=script&lang=js"
import style0 from "./ChatPanel.vue?vue&type=style&index=0&id=d4a96bfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4a96bfe",
  null
  
)

export default component.exports